export default "__VITE_ASSET__BFHrNDSt__"